export enum HoursOfOperationType {
    SelectHours = 0,
    AlwaysOpen = 1,
    Closed = 2,
    Unknown = 3
}
